import { UsStateInput } from "@/components/common/inputs/UsStateInput";
import { ClientStatus, ResourceName } from "@/types";
import { getInputProps } from "@/utils/helpers/columnsHelper";
import { Box, Stack } from "@mui/material";
import { TextInput, BooleanInput } from "react-admin";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const getClientInputProps = (key: string, textReplace = {}) => getInputProps(key, textReplace, ResourceName.CLIENTS);

export const ClientCreateInputs = () => {
  const { setValue } = useFormContext();

  // Set default client_status — backend requires this field
  useEffect(() => {
    setValue("client_status", ClientStatus.BUILDING, { shouldDirty: false, shouldValidate: false });
  }, [setValue]);

  return (
    <Box p={2}>
      {/* Company Information */}
      <Stack direction="row" spacing={1}>
        <TextInput {...getClientInputProps("client_legal_name")} required fullWidth size="small" />
        <TextInput {...getClientInputProps("client_short_name")} fullWidth size="small" />
      </Stack>

      {/* Location and Parent Company */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <UsStateInput {...getClientInputProps("client_state_headquartered")} fullWidth size="small" />
        <TextInput {...getClientInputProps("client_parent_co")} fullWidth size="small" />
        <TextInput {...getClientInputProps("broker_agent_of_record")} fullWidth size="small" />
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <BooleanInput {...getClientInputProps("has_children_co")} size="small" />
      </Stack>
    </Box>
  );
};
